module.exports = __webpack_public_path__ + "static/intro-hero-a00fbc552f70e57164a5498c5c05b575.png";